module.exports = __webpack_public_path__ + "static/media/kagi.49190eb4.svg";